/*
 * @Author: yejianfei
 * @Date: 2023-04-03 10:37:15
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-05-21 21:31:33
 * @Description:
 * @Developer:
 */
import React from 'react';
import View from './View';
import './BorderLayout.scss';
import { isArray } from 'lodash';
export function BorderCenter(props) {
    return (React.createElement(View, { className: 'center-panel' }, props.children));
}
export function BorderNorth(props) {
    return (React.createElement(View, { style: { height: props.height || 'auto' }, className: 'north-panel' }, props.children));
}
export function BorderSouth(props) {
    return (React.createElement(View, { style: { height: props.height || 'auto' }, className: 'south-panel' }, props.children));
}
export function BorderWest(props) {
    return (React.createElement(View, { style: { width: props.width || 'auto' }, className: 'west-panel' }, props.children));
}
export function BorderEast(props) {
    return (React.createElement(View, { style: { width: props.width || 'auto' }, className: 'east-panel' }, props.children));
}
//.north-pane
export default function BorderLayout(props) {
    const chidren = (isArray(props.children) ? props.children : [props.children])
        .reduce((previous, current) => {
        if (current.type === BorderCenter) {
            previous.center = current;
        }
        if (current.type === BorderNorth) {
            previous.north = current;
        }
        if (current.type === BorderSouth) {
            previous.south = current;
        }
        if (current.type === BorderWest) {
            previous.west = current;
        }
        if (current.type === BorderEast) {
            previous.east = current;
        }
        return previous;
    }, {});
    return (React.createElement(View, { className: 'boder-layout', style: props.style },
        chidren.north,
        React.createElement(View, { className: 'center-container' },
            chidren.west,
            chidren.center,
            chidren.east),
        chidren.south));
}
